//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import * as moment from "moment";
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';

// custom pages
import Table from "components/Table/Table";
import role from "apis/role/role";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HistoryTable from "components/Table/History/HistoryTable";
import { blockInvalidChar } from 'helpers/blockInvalidChar';

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';

// material-ui icons
import { Grid, MenuItem } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';

// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      background: 'transparent',
    },
    '& .MuiFormLabel-root': {
      background: 'transparent',
    },
    '& .MuiInputBase-input': {
      background: 'transparent',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#000 !important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000 !important',
    },
  },
})(TextField);


export default function Role(props) {
  const { state, dispatch } = useContext(context);
  const { getRoles, getscreen, getuser, assignUser, getRoleList } = role();
  const { t, i18n } = useTranslation();

  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const [screen, setscreen] = useState([]);
  const [screenMapping, setScreenMapping] = useState([]);
  const [errors, setErrors] = useState({});
  const [isActive, setIsActive] = useState(true);

  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "ROLE"] });
  }, []);

  const [states, setstates] = useState({ 
    historyLoader: false, 
    searchUser: '', 
    shiptoList: [],
    selectedRole: null,
    selectedUser: '',
    shiptoLoading: false,
    roleList: [],
    searchUserRole:''
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset, isActive]);

  useEffect(() => {
    handleGetRoles();
  }, [])


  useEffect(() => {
    if(states.searchUser && states.searchUser.length > 0){
      handleuserSearch();
    }
  }, [states.searchUser])

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10
      };
      let res = await getRoles(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };

  // get api func
  const handleGetRoles = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });      
      let res = await getRoleList();
      if (res) {
        setStates({roleList: res?.data})
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };

  function handleuserSearch() {
    let obj = {     
      searchValue: states?.searchUser
    }
    setStates({shiptoLoading: true})
    getuser(obj)
      .then(res => {
        if(res) {
          setStates({shiptoList: res?.data})
        }
      })
      .catch(err => {
        console.log({err});        
      })
    setStates({shiptoLoading: false})
  }

  function handleAssignUser() {
    const {selectedRole, selectedUser,searchUserRole} = states;
    if(selectedRole == null || selectedUser.length == 0){
      return toast.warn('Please select all the fields', {toastId: 'assignUserErr'})
    }
    console.log(searchUserRole,"searchUserRole",state?.user)
    if(searchUserRole == 13 && state?.userInfo?.role_id !== 10 ){
      return toast.warn('You Cannot Change the super admin role', {toastId: 'assignUserErr'})
    }
    let obj = {     
      roleId: selectedRole,
      userId: selectedUser
    }
    setStates({shiptoLoading: true})
    assignUser(obj)
      .then(res => {
        if(res && res.status == 200) {
          toast.success(res.message);
          setOpen(false);
          setStates({
            historyLoader: false, 
            searchUser: '', 
            shiptoList: [],
            selectedRole: null,
            selectedUser: '',
            searchUserRole:'',
            shiptoLoading: false
          });
        }
      })
      .catch(err => {
        console.log({err});        
      })
    setStates({shiptoLoading: false})
  }

  const handleClose = () => {
    setOpen(false);
    setStates({
      historyLoader: false, 
      searchUser: '', 
      shiptoList: [],
      selectedRole: null,
      selectedUser: '',
      searchUserRole:'',
      shiptoLoading: false
    });
  };

  const handleOpen = () => {
    setOpen(true);
  };  

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <div>          
          <Button
            className={`${classes.createBtn} dash-1-filter-btn`}
            onClick={() => {
              history.push("/dashboard/create-role");
            }}
          >
            {'Create Role'}
          </Button> 
          <Button
            className={`${classes.assignBtn} dash-1-filter-btn`}
            onClick={handleOpen}
          >
            {'Assign Role'}
          </Button>        
        </div>
      </Grid>
      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
            {res ? (
              <Table
                headings={[      
                  "Role",                                
                  "Status",
                  "View Details"
                ]}
                data={
                  data &&
                  data.length > 0 &&
                  data.map((d, i) => [                                
                    d?.role_name,                                      
                    d?.is_active ? (
                      <span style={{ color: "green" }}>Active</span>
                    ) : (
                      <span style={{ color: "red" }}>Inactive</span>
                    ),
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/view-role", { data: { ...d } });
                      }}
                    >
                      <VisibilityIcon />
                    </div>
                  ])
                }
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            ) : (
              <Loader Loading={true} top={"15%"} />
            )}
          </Grid>
        </Grid>
      </Loader>

      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
        fullWidth
        maxWidth='xs'
        disableBackdropClick
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <CloseOutlinedIcon
            className={classes.closeIcon}
            onClick={handleClose}
          />
          <div
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {t('Assign Role to User')}
          </div>
          <DialogContentText id='alert-dialog-slide-description'>
            <Grid
              container
              item
              xs={12}
              spacing={Object.keys(errors).length > 2 ? 0 : 2}
            >    
              <Grid item xs={12}></Grid>
              <Grid item xs={12}></Grid>        
              <Grid item xs={12}>
                <Autocomplete
                  id='shipto-search'
                  autoSelect={true}
                  options={states?.shiptoList}
                  getOptionLabel={(o) => o.full_name}
                  filterOptions={(options, state) => options}
                  inputValue={states?.searchUser}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='outlined'
                      type='text'                      
                      value={states?.searchUser}
                      placeholder={t('Search User by Name or Email')}
                      onChange={(e) => {
                        setStates({ searchUser: e.target.value });
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {states?.shiptoLoading ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}                                                 
                    />
                  )}
                  onChange={(value, a, reason) => {
                    if (reason === 'clear') {
                      setStates({ searchUser: '' });
                      setStates({ selectedUser: '' })
                      setStates({ searchUserRole: '' })

                      return;
                    }
                    if (a) {
                      setStates({ selectedUser: a.user_id })
                      setStates({ searchUser: a.full_name })
                      setStates({ searchUserRole: a.role_id })

                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='role'
                  label={t('Select Role')}
                  variant="outlined"
                  select
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  onChange={(e) => {                    
                    setStates({selectedRole: e.target.value});
                  }}
                  value={states.selectedRole || ''}
                >
                  {states?.roleList?.filter(rl => (rl.is_cdr_admin == true  &&rl.role_id != 13 && rl.role_id != 10 )).map((item) => {
                    return (
                      <MenuItem key={t(item.role_id)} value={item.role_id}>
                        {t(item.role_name)}
                      </MenuItem>
                    );
                  })}
                </CssTextField>
                {errors.role && (
                  <span className={classes.errorMsg}>{errors.role}</span>
                )}
              </Grid>
              <Grid item xs={12}>                
              </Grid>
            </Grid>
            <div className={classes.popupBtnDiv}>
              <button className={classes.submitBtn} onClick={handleAssignUser}>
                {!state.loading ? t('Submit') : `${t('Please wait')}..`}
              </button>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {'History'}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}` : "",
                  `${d?.["User.email"] ? d?.["User.email"] : d?.altered_by ? d?.altered_by.charAt(0).toUpperCase() + d?.altered_by.slice(1).toLowerCase() : "-"}`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
